(function AgentAttachmentsAttachmentCategories($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/AgentAttachments/attachmentCategories', function onload()
		{
			var $category_template = $("#add-edit-category.template");

			// add category
			$("a.add-category").on('click', function addCategory(e)
			{
				e.preventDefault();

				// hackfix: form.js doesn't isolate an errored input to its own form
				// and just uses general id-based selectors, so in this case it
				// applies the .has-error class to the template form :(
				$category_template.find('.has-error').removeClass('has-error');
				$category_template.find('#agentattachmentaddeditcategory-category_id').val('');
				$category_template.find('#agentattachmentaddeditcategory-category_name').attr('value', '');
			});

			// edit category
			$("a.edit-category").on('click', function editCategory(e)
			{
				var $self    = $(this),
				    category = $self.parents('.table-row').find('p:first-child > span:nth-child(2)').text();

				e.preventDefault();

				// hackfix: form.js doesn't isolate an errored input to its own form
				// and just uses general id-based selectors, so in this case it
				// applies the .has-error class to the template form :(
				$category_template.find('.has-error').removeClass('has-error');
				$category_template.find('#agentattachmentaddeditcategory-category_id').val($self.data('category-id'));
				$category_template.find('#agentattachmentaddeditcategory-category_name').attr('value', category);
			});
		});
	});

}(jQuery, window.Adzuki || {}));
